import * as React from 'react';

import { type TFilter, type TOpenedFiltersState } from '@/packages/Filters/shared/types/filters';

interface IFiltersOpenedState {
  openedFilters: TOpenedFiltersState;
  openFilter: (filter: TFilter) => void;
  closeFilter: (filter: TFilter) => void;
}

interface IParameters {
  onOpenFilter?: IFiltersOpenedState['openFilter'];
  onCloseFilter?: IFiltersOpenedState['closeFilter'];
}

export function useFiltersOpenedState(parameters: IParameters = {}): IFiltersOpenedState {
  const { onOpenFilter, onCloseFilter } = parameters;
  const [openedFilters, setOpenedFilters] = React.useState<TOpenedFiltersState>({});

  const openFilter = React.useCallback(
    (filter: TFilter) => {
      setOpenedFilters(state => ({ ...state, [filter]: true }));

      if (onOpenFilter) {
        onOpenFilter(filter);
      }
    },
    [onOpenFilter],
  );

  const closeFilter = React.useCallback(
    (filter: TFilter) => {
      setOpenedFilters(state => ({ ...state, [filter]: false }));

      if (onCloseFilter) {
        onCloseFilter(filter);
      }
    },
    [onCloseFilter],
  );

  return React.useMemo(
    () => ({
      openedFilters,
      openFilter,
      closeFilter,
    }),
    [closeFilter, openFilter, openedFilters],
  );
}
